// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fallbackIcon---Q6qEg {
  width: inherit;
  height: inherit;
  display: flex !important;
  justify-content: center;
  align-items: center;
  background-color: gray;
}
`, "",{"version":3,"sources":["webpack://./src/components/img_with_fallback.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;EAEA,wBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,sBAAA;AADF","sourcesContent":[".fallbackIcon {\n  width: inherit;\n  height: inherit;\n\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n\n  background-color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fallbackIcon": `fallbackIcon---Q6qEg`
};
export default ___CSS_LOADER_EXPORT___;
